module.exports = __webpack_public_path__ + "fonts/a757947.ttf";